import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css'; // If you have any global styles

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

// Remove ethereum.connect if present to avoid unexpected MetaMask connect attempts
// (This prevents extension-injected calls from triggering noisy console errors.)
if (typeof window !== 'undefined' && window.ethereum && 'connect' in window.ethereum) {
  try {
    delete window.ethereum.connect;
    console.info('Removed window.ethereum.connect to avoid extension connect calls');
  } catch (e) {
    // ignore
  }
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
